export default function guest ({ next, store, cookie, to, Vue }) {
  const session = JSON.parse(cookie.get('session'))
  if (session) {
    store.commit('auth/setToken', session.token)
    store.commit('auth/setUser', session.user)
    if (session.user && session.token) {
      store.commit('auth/setLocale', session.user.language)
      Vue.axios.defaults.headers.common.Authorization = `Bearer ${session.token}`
    }
  }
  if (store.state.auth.loggedIn && (to.name === 'Login' || to.name === 'Register')) {
    return next({
      name: 'Dashboard'
    })
  }
  return next()
}
